// extracted by mini-css-extract-plugin
export default {"container":"activity_matches-module___container___e618b169"};